module.exports = __webpack_public_path__ + "media/images/icon_bbs_white-df67b83b6ddcdc33c1f64a6e965bea19.png";